import React from "react";
import { Modal } from "react-bootstrap";
import { Button } from "core/components";

type AttentionModalProps = {
  show: boolean;
  onClose: () => void;
};

const AttentionModal = ({ show,  onClose }: AttentionModalProps): JSX.Element => {
  return (
      <Modal show={show}>
        <Modal.Header>Attention Required!</Modal.Header>
        <Modal.Body>
          We have detected some changes in the data on this page. To ensure you are viewing the most up-to-date information, please refresh the page.
        </Modal.Body>
        <Modal.Footer>
        
          <Button
            onClick={() => {
              onClose();
            }}
            icon="times"
            title="Close"
          />
          <Button
            className="button--success"
            icon="reload"
            onClick={() => {
              location.reload();
            }}
            title="Reload Page"
          />
        </Modal.Footer>
      </Modal>
  );
};

export default AttentionModal;
